import { createContext } from 'react'

// HotelSearchMapPage enables this layout for the experiment.
export const SearchMapRedesignContext = createContext(false)
export const SearchMapCardCloseContext = createContext<(() => void) | undefined>(undefined)

export const SearchMapPriceLayoutContext = createContext<'row' | 'card' | undefined>(undefined)
export const SearchMapHoveredOfferContext = createContext<string | undefined>(undefined)
